'use strict'

const isError_ = require('lodash/isError')
const errorBoundaries = require('wix-error-boundaries')

const { isDatasetError } = require('../dataset-controller/DatasetError')

const USER_SCOPE = 'userCodeZone'
const APPLICATION_SCOPE = 'applicationCodeZone'
const WIX_DATA_SCOPE = 'wixDataCodeZone'
const WIX_DATA_USER_ERROR_CODES = [
  'WD_SITE_IN_TEMPLATE_MODE',
  'WD_PERMISSION_DENIED'
]
const WIX_DATA_UNKNOWN_ERROR = 'WD_UNKNOWN_ERROR'
const handled = Symbol('error was handled')

const isErrorHandled = e => e[handled]

const isUserError = (error, scope) =>
  isDatasetError(error.name) ||
  scope === USER_SCOPE ||
  (scope === WIX_DATA_SCOPE && WIX_DATA_USER_ERROR_CODES.includes(error.code))

const isWixDataError = error => error.code === WIX_DATA_UNKNOWN_ERROR

const reportException = (raven, e) => {
  raven.captureException(e)
  e[handled] = true
}

const dbsmViewerErrorHandler = (ravenInstances, e, scope) => {
  const { Raven, UserRaven, WixDataRaven } = ravenInstances
  if (!isError_(e) || isErrorHandled(e)) {
    return
  }
  if (isUserError(e, scope)) {
    reportException(UserRaven, e)
  } else if (isWixDataError(e)) {
    reportException(WixDataRaven, e)
  } else if (scope === APPLICATION_SCOPE) {
    reportException(Raven, e)
  }
}

module.exports = ravenInstances => {
  return errorBoundaries({
    scopes: [USER_SCOPE, APPLICATION_SCOPE, WIX_DATA_SCOPE],
    errorHandler: dbsmViewerErrorHandler.bind(undefined, ravenInstances)
  })
}

module.exports.isErrorHandled = isErrorHandled



// WEBPACK FOOTER //
// ./error-boundaries/errorBoundaries.js